export default {
  title: {
    en: 'Scentbird Monthly Perfume Subscription Box: Designer Scents {price}',
  },
  description: {
    en: `
      Discover the latest perfumes and colognes at Scentbird. Date perfumes before marrying them.
      Explore over 600 designer fragrances. Get new designer scent every month for just {price}. Free shipping.
    `,
  },
}
